<template>
  <div class="plv-ia-radio">
    <input
      :id="audioId"
      type="radio"
      :name="name"
      :value="value"
      :required="required"
      :disabled="disabled"
      :checked="state"
      @change="onChange"
    />
    <label :for="audioId">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CommonRadio',
  model: {
    prop: 'modelValue',
    event: 'input'
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: undefined,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      audioId: '',
    };
  },

  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      return this.modelValue === this.value;
    }
  },

  watch: {
    checked(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    }
  },

  beforeMount() {
    const fingerprint = `radio-${new Date().getTime() % 1000}-${Math.floor(Math.random() * 100000)}`;
    this.audioId = this.id || fingerprint;
  },

  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  },

  methods: {
    async onChange() {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 0);
      });
      this.toggle();
    },

    toggle() {
      this.$emit('input', this.state ? '' : this.value);
    }
  },
};
</script>

<style lang="scss">
$height: 16px;

.plv-ia-radio {
  height: $height;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;

  > input {
    opacity: 0;
    position: absolute;
    height: $height;
    cursor: pointer;

    + label {
      height: $height;
      line-height: $height;
      vertical-align: top;
      color: #333;
      cursor: pointer;
      position: relative;
      padding-left: $height + 6px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto;

        border: 1px solid #CFD8DC;
        border-radius: 50%;
        width: $height;
        height: $height;
        background: #fff;
        user-select: none;
        box-sizing: border-box;
      }

      &:hover:before {
        border-color: #2196F3;
      }
    }

    &:checked + label:before {
      border: solid 5px #2196F3;
    }

    &:disabled {
      cursor: not-allowed;
    }

    &:disabled + label {
      opacity: 0.7;
      cursor: not-allowed;

      &::before {
        border-color: #CFD8DC;
      }
    }
  }
}
</style>
